import { render, staticRenderFns } from "./SheetTeacherViewRegister.vue?vue&type=template&id=1c8b06f2"
import script from "./SheetTeacherViewRegister.vue?vue&type=script&lang=js"
export * from "./SheetTeacherViewRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8b06f2')) {
      api.createRecord('1c8b06f2', component.options)
    } else {
      api.reload('1c8b06f2', component.options)
    }
    module.hot.accept("./SheetTeacherViewRegister.vue?vue&type=template&id=1c8b06f2", function () {
      api.rerender('1c8b06f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/SheetTeacherViewRegister.vue"
export default component.exports